import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'

export const Ztag = z.object({
  name: z.string()
})

export const ZGatewayInfo = z.object({
  gateway_name: z.string(),
  created_on: z.string(),
  description: z.string(),
  image: z.string()
})

export const ZData = z.object({
  assets: ZGatewayInfo.array()
})

export const ZApiResponse = z.object({
  http_status: z.any(),
  data: z.optional(ZData),
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export type GatewayInfo = z.infer<typeof ZGatewayInfo>
export type Tag = z.infer<typeof Ztag>

export async function gatewayInfoService (
  gatewayId: string,
  assetId: string,
  onSuccess: (gatewayInfo: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const DeviceManagementStrings = LanguageStrings().DeviceManagementCollectionStrings.TableComponent

  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const url = `/assetrest/api/v2/udp/tiq/assets/${gatewayId}?assetId=${assetId}`

  interceptedAxios.get(url, { timeout: 15000 })
    .then((response) => {
      const parseResponse = response.data
      // istanbul ignore else
      if (parseResponse.error === false) {
        // istanbul ignore else
        if (parseResponse.data !== null && parseResponse.data !== undefined) {
          onSuccess(parseResponse.data, parseResponse.http_status)
        } else {
          onFailure(parseResponse.error, parseResponse.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore next
      if (error.response !== undefined) {
        onFailure((error.response.data !== undefined || error.response.data !== null) ? error.response.data.error_message : DeviceManagementStrings.NetworkError, error.response.status)
      } else {
        onFailure(DeviceManagementStrings.NetworkError, 404)
      }
    })
}
